import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AbilityService } from 'ability';
import { RoutingPath } from 'mbs-ui-shared@constants';
import { canSeeDocuments } from 'mbs-ui-shared@utils/documents/documents.permissions';

/**
 * Guards the pages of the documents module. A guard of its own rather than the permission list of
 * PermissionsGuard: that list asks for every permission in it, and the two roles are allowed in by
 * permissions of their own, one each.
 *
 * @return {boolean | UrlTree} True, or where to send an administrator documents are closed to.
 */
export const documentsGuard: CanActivateFn = (): boolean | UrlTree => {
  const ability = inject(AbilityService);

  if (canSeeDocuments(ability)) {
    return true;
  }

  return inject(Router).createUrlTree([ability.can('read', 'Provider') ? RoutingPath.ApDefaultAspx : RoutingPath.ApSettings]);
};
